import endpointsList from './endpoints'

// based on webpack.Define plugin
const API_URL = process.env.VUE_APP_API_URL

/**
 * fetch our web service in JSON mode
 *
 * @param  {string} url     endpoint to match
 * @param  {object} options options to fetch API
 * @return {Promise}        Promise with the JSON response
 */
export async function fetchJSON (url, options = {}) {
  let opt = {}

  // merge options
  opt = Object.assign(
    {},
    {
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    },
    options
  )

  if (opt.body) {
    opt.body = JSON.stringify(opt.body)
  }

  return new Promise(async function (resolve, reject) {
    try {
      const res = await fetch(`${API_URL}/${url}`, opt)

      if (res.status >= 200 && res.status < 400) {
        resolve(res.json())
      } else if (res.status === 401) {
        /* eslint-disable prefer-promise-reject-errors */
        reject({
          message: res.statusText,
          code: 401,
          content: await res.json()
        })
      } else if (res.status === 403) {
        /* eslint-disable prefer-promise-reject-errors */
        reject({
          message: res.statusText,
          code: 403
        })
      } else {
        const resJson = await res.json()
        reject(resJson)
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const endpoints = endpointsList
